module.exports = __webpack_public_path__ + "img/task-cover.aefe0e3c.png";